<script setup>
  import InfosAffaire from '@/components/InfosAffaire.vue'
  //import ListeFichiersAffaires from '@/components/ListeFichiersAffaires.vue'
</script>

<template>
  <div class="home">
      <button class="back mt-4" @click="goBack"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
      </svg>Retour</button>
      <div class="container my-5">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
             <div class="col-lg-6">
              <div class="infos">
                <p class="titre">AFFAIRE : <strong>{{ naf }}</strong></p>
                <p><strong>{{ piece }}</strong></p>
                <p style="font-weight: 600;" v-if="designation.trim() != '' && designation.trim() != 'empty'">{{ designation }}</p>
              <p style="font-weight: 600;" v-if="designation2.trim() != '' && designation2.trim() != 'empty'">{{ designation2 }}</p>
              <p style="font-weight: 600;" v-if="designation3.trim() != '' && designation3.trim() != 'empty'">{{ designation3 }}</p>
              </div>
            
             </div>
             <div class="col-lg-6">
              <div class="infos">
                <p>Commande client : {{ cocde }}</p>
                <p>Quantité à produire : {{ qte }}</p>
                <p>Quantité restant à produire : {{ qte_rest }}</p>
                 <p>Délais de production interne : {{ formatDate(delais_interne) }}</p>
                <p>Délais de production : {{ formatDate(delais) }}</p>
                <p>Disponibilité :</p>
                <div class="prog" v-if="dispo">
                  <p>{{ dispo.dispo + '%' }}</p>
                  <div class="progress-bar">
                    <span :style="{ width: dispo.dispo + '%' }"></span>
                  </div>
                </div>
                <div class="prog" v-else>
                  <p>Pas de matériel lié</p>
                </div>
              </div>
             </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="clientContainer">
            <img class="barcode" alt='Barcode Generator TEC-IT'
            :src="'https://barcode.tec-it.com/barcode.ashx?data=0000' + naf + '&code=Code39&multiplebarcodes=true'"/>
            <img class="logoClient" :src="'https://www.simef.fr/espace-client/espaces-perso/clients/' + client + '/logos/logo.jpg?' + Date.now()" alt="">
          </div>
        </div>
      </div>
    </div>
   
   
    <div class="container">

      
      <div class="row">
        <div class="col-lg-4">
          <div class="encart">
            <div v-if="utilisateursSelectionnes[0] !== ''">
              <h2>Opérateur(s) affecté(s) / affaire</h2>
              <ul class="usersList">
                <li v-for="(user, index) in utilisateursSelectionnes" :key="index"><a :href="'mailto:'+user"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                  </svg>{{ user }}</a></li>
              </ul>
            </div>
            <div v-else>
              <div class="usersList">
                <h2>Opérateur(s) affecté(s) / affaire</h2>
                <p>Aucun opérateur(s) affecté(s)</p>
              </div>
         
            </div>
            <div class="message"></div>
          </div>
          <div class="encart">
            <h2>Message externe</h2>
            <p v-if="message_externe">{{ message_externe }}</p>
            <p v-else>Pas de message externe</p>
          </div>
          <div class="encart">
            <h2>Message interne</h2>
            <p v-if="message_interne">{{ message_interne }}</p>
            <p v-else>Pas de message interne</p>
          </div>

          
        </div>
        <div class="col-lg-4">
          <div class="fichiersAcces encart">
            <h2>Fichiers Disponibles</h2>
            <!--<ListeFichiersAffaires />-->
            <RouterLink :to="'/fichiers-client/' + clientName"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
            </svg>Fichiers et photos du client</RouterLink>
            <RouterLink :to="'/fichiers-affaire/' + naf"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
            </svg>Fichiers et photos de l'affaire</RouterLink>
          </div>

          <div class="com encart">
            <h2>Envoyer un commentaire</h2>
            <form @submit.prevent="submitCom">
            
              <!-- Remplacement du select des rôles par la liste des emails -->
              <div class="checkbox-group destinataires-group">
                <label class="checkbox-option" v-for="email in destinatairesEmails" :key="email">
                  <input type="checkbox" v-model="destinataires" :value="email"> {{ email }}
                </label>
              </div>
              <input type="text" v-if="motif === 'Autre'" v-model="autreMotif" placeholder="Entrez votre motif ici" />
              <textarea id="commentaire_motif" rows="5" v-model="commentaire_motif" placeholder="Entrez votre commentaire ici"></textarea>
              
              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-fill" viewBox="0 0 16 16">
              <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"/>
              </svg>Envoyer ma demande</button>

              <div v-if="confirmationMessageCom" class="alert alert-success" role="alert">
                {{ confirmationMessageCom }}
              </div>
              <div v-if="errorMessageCom" class="alert alert-danger" role="alert">
                {{ errorMessageCom }}
              </div>
            </form>
          </div>
        </div>
        <!--<div v-if="loggedInRole=='admin'" class="col-lg-4">
          <div class="fichiers encart">
            <h2>Ajouter un fichier</h2>
            
            <form @submit.prevent="submit">
              <input type="file" @change="addFichiers" accept="image/*,.pdf" capture>
              <div>
                <input type="text" id="nomFichier" v-model="nomFichier" placeholder="Nom du fichier">
              </div>
              <div>
                <input type="hidden" id="utilisateur" v-model="utilisateur" required>
              </div>
              <div>
                  <input type="hidden" id="naf" v-model="naf" required>
              </div>
    
              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Envoyer le/les fichier(s)</button>
    
    
    
              <div v-if="confirmationMessage" class="alert alert-success" role="alert">
                {{ confirmationMessage }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger" role="alert">
                {{ errorMessage }}
              </div>
            </form>
          </div>
          
        </div>-->
        <div class="col-lg-4">
          
          <div class="solder encart">
            <h2>État de la production</h2>
            <form @submit.prevent="submitProd">
              <select id="etat" v-model="etat" required>
                <option value="Production partielle">Production partielle</option>
                <option value="Production complète">Production complète</option>
              </select>
              <input v-if="etat == 'Production partielle'" type="number" id="quantite" v-model="quantite" placeholder="Quantité" required step="0.1" :max="qte">
              <input type="time" id="duree" v-model="duree" placeholder="Durée (HH:MM)" required step="60">
              <p class="small">Durée de production au format heures:minutes (ex : 1:30)</p>

              <template v-if="etat == 'Production complète'">
                <h3 class="colisage-titre">Colisage</h3>
                <input type="number" v-model="nbColis" placeholder="Nombre de colis" required min="1" step="1" />
                <input type="text" v-model="dimensions" placeholder="Dimensions en mètre" required />
                <input type="number" v-model="poidsGlobal" placeholder="Poids global (kg)" required step="0.01" min="0" />
              </template>

              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-fill" viewBox="0 0 16 16">
              <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"/>
              </svg>Valider</button>
    
              <div v-if="confirmationMessage" class="alert alert-success" role="alert">
                {{ confirmationMessage }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger" role="alert">
                {{ errorMessage }}
              </div>
            </form>
          </div>

          
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-12">
          <div>
            <InfosAffaire/>
          </div>
        </div>
      </div>
    </div>
    
    
    
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js';
import VueCookies from 'vue-cookies'

export default {
  data() {
      return {
        designation: null,
        designation2: null,
        designation3: null,
        naf: null,
        utilisateur: '',
        loggedInRole: null,
        loggedInEmail: null,
        utilisateursSelectionnes: [],
        nomFichier: '',
        fichiers: [],
        confirmationMessage: '',
        errorMessage: '',
        confirmationMessageCom: '',
        errorMessageCom: '',
        cocde: '',
        piece: '',
        qte: '',
        qte_rest: '',
        delais: '',
        delais_interne: '',
        duree: '',
        quantite: '',
        client: '',
        etat: 'Production partielle',
        clientName: '',
        message_interne: '',
        message_externe: '',
        userRole: 'gestion', // à supprimer
        commentaire_motif: '',
        dispo: '',
        destinatairesEmails: [], // Ajouté
        destinataires: [], // Ajouté
        nbColis: '',
        dimensions: '',
        poidsGlobal: '',
      };
  },
  mounted() {

    const nom = VueCookies.get('nom')
    if (nom) {
        this.utilisateur = nom
    }
    const prenom = VueCookies.get('prenom')
    if (prenom) {
      this.utilisateur += " " + prenom;
    }
      // Envoyer les données d'inscription au serveur
      axios.post('https://www.simef.fr/espace-client/api/getUtilisateursRelies.php', {
        affaire: this.naf
      })
      .then(response => {
        this.utilisateursSelectionnes = response.data.split(',');
        //console.log(this.utilisateursSelectionnes);
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
      

      axios.post('https://www.simef.fr/espace-client/api/getAffaire.php', {
        naf: this.naf
      })
      .then(response => {
        this.cocde = response.data[0].cocde;
        this.piece = response.data[0].piece;
        this.qte = response.data[0].qte;
        this.qte_rest = response.data[0].qte_rest;
        this.delais = response.data[0].delais;
        this.delais_interne = response.data[0].delais_interne;
        this.message_interne = response.data[0].message_interne;
        this.message_externe = response.data[0].message_externe;
      })
      .catch(error => {
          console.error(error);
      });


      axios.post('https://www.simef.fr/espace-client/api/getDispos.php', {
        naf: this.naf
      })
      .then(response => {
        this.dispo = response.data;
      })
      .catch(error => {
          console.error(error);
      });

      axios.post('https://www.simef.fr/espace-client/api/getInternUtilisateurs.php')
        .then(response => {
          this.destinatairesEmails = response.data;
        })
        .catch(error => {
          console.error('Erreur lors de la récupération des emails internes:', error);
        });
      
      
  },
  created() {
        this.designation = this.$route.params.designation;
        this.designation2 = this.$route.params.designation2;
        this.designation3 = this.$route.params.designation3;
        this.naf = this.$route.params.naf
        this.client = this.$route.params.client;

        const email = VueCookies.get('email')
        if (email) {
          this.loggedInEmail = email
        }
        const role = VueCookies.get('role')
        if (role) {
          this.loggedInRole = role
        }

        axios.post('https://www.simef.fr/espace-client/api/getClientName.php', {
          client: this.client
        })
        .then(response => {
          this.clientName = response.data.nom;
        })
        .catch(error => {
            console.error(error);
        });
    },
  methods: {
    convertirDureeEnDecimal(duree) {
      // Convertit "HH:MM" en heures décimales (ex: "1:30" -> 1.5)
      if (!duree) return '';
      if (typeof duree === 'number') return duree;
      const parties = String(duree).split(':');
      if (parties.length !== 2) return duree;
      const heures = parseInt(parties[0], 10) || 0;
      const minutes = parseInt(parties[1], 10) || 0;
      return +(heures + minutes / 60).toFixed(4);
    },
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    goBack() {
      const queryParams = {
        page: this.currentPage,
        searchTerm: this.searchTerm,
      };
      this.$router.go(-1);
      this.$router.push({ query: queryParams });
    },
    /*submit() {
      // Create a new FormData object
      const formData = new FormData();

      // Ajouter les fichiers au formulaire
      for (let i = 0; i < this.fichiers.length; i++) {
          formData.append('fichiers[]', this.fichiers[i]);
      }
      // Add the user and chantier information to the form data
      formData.append('nomFichier', this.nomFichier);
      formData.append('utilisateur', this.utilisateur);
      formData.append('naf', this.naf);

      
      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutFichiersAffaires.php', formData)
      .then(response => {
          // Handle the response from the server
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
          this.fichiers = [];
          this.nomFichier = '';
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
          this.fichiers.push(files[i]);
      }
    }*/
    submitProd() {
      const dureeDecimale = this.convertirDureeEnDecimal(this.duree);
      axios.post('https://www.simef.fr/espace-client/api/ajoutDonneeProduction.php', {
        naf: this.naf,
        etat: this.etat,
        utilisateur: this.loggedInEmail,
        nomPrenom: this.utilisateur, 
        duree: dureeDecimale,
        quantite: this.quantite,
        utilisateursSelectionnes: this.utilisateursSelectionnes,
        desa1: this.designation,
        desa2: this.designation2,
        desa3: this.designation3,
        commandeClient: this.cocde,
        qte: this.qte,
        delais: this.formatDate(this.delais),
        nbColis: this.nbColis,
        dimensions: this.dimensions,
        poidsGlobal: this.etat === 'Production complète' ? this.poidsGlobal : null,
      })
      .then(response => {
          // Handle the response from the server
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
          this.duree = '';
          this.quantite = '';
          this.nbColis = '';
          this.dimensions = '';
          this.poidsGlobal = '';
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    submitCom() {
      axios.post('https://www.simef.fr/espace-client/api/sendEmail.php', {
       destinataires: this.destinataires,
       commentaire_motif: this.commentaire_motif,
       utilisateur: this.utilisateur, 
       affaire: this.naf,
      })
      .then(response => {
          this.confirmationMessageCom = response.data.success;
          this.errorMessageCom = response.data.error;
          this.destinataires = [];
          this.commentaire_motif = '';
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    }
  }
}
</script>

<style lang="scss">
.fichiersAcces {
  display: flex;
  flex-direction: column;
  a {
    padding: 8px 25px !important;
    font-weight: 500;
    background: #2b358d !important;
    color: #fff!important;
    margin-bottom: 10px;
    align-items: center;
    &:hover {
      color: #fff;
    }
    svg {
      margin-right: 15px;
    }
  }
}
.infos {
  @media screen and (max-width:992px) {
    text-align: center;
  }
  .titre {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 0px;
  }
}

.barcode {
  height: 70px;
  margin-bottom: 20px;
}

form {
  input, select {
    margin-bottom: 10px!important;
  }
}

button.back {
  display: inherit;
  margin: auto;
  margin-bottom: 20px!important;
  display: flex;
  align-items: center;
 }

 @media screen and (max-width:992px) {
    .back {
      margin-top: 30px!important;
    }
 }
 button.back svg {
  height: 24px;
  width: 24px;
  margin-right: 6px;
 }

 .usersList {
  text-align: left;
  margin: 0px;
  list-style: none;
  padding: 0px;
  a {
    font-weight: 500;
    display: flex;
    align-items: center;
    color: #1d1d20;
    svg {
      margin-right: 10px;
      height: 17px;
      width: 17px;
    }
  }
 }
.logoClient {
  height: 50px;
}
.small {
  font-size: 0.7rem;
  font-style: italic;
  margin-bottom: 0px;
}

.clientContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
@media screen and (max-width:992px) {
  .clientContainer {
    margin-top: 30px;
  }
}
.prog {
  text-align: center;
  width: 60%;
  @media screen and (max-width:992px) {
    margin: auto;
  }
  p {
    margin: 0px;
    margin-bottom: 2px;
    font-size: 0.7rem;
  }
}
.progress-bar {
  width: 100%; /* Ajustez la largeur selon votre mise en page */
  height: 8px; /* Ajustez la hauteur selon votre mise en page */
  background-color: #e0e0e0!important; /* Couleur de fond de la barre */
  span {
    background: #2b358d;
    height: 100%;
  }
}
.colisage-titre {
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: none;
  margin-top: 12px;
  margin-bottom: 12px;
}

.checkbox-group.destinataires-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
  align-items: center;
  width: 100%;
  min-width: 260px;
  background: #f7f7f7;
  padding: 8px;
  border-radius: 0px;
  border: 1px solid #d4d4d4;
}
.com.encart {
  .checkbox-option {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
    background: #f7f7f7;
    border-radius: 0;
    font-weight: 500;
    cursor: pointer;
    input[type="checkbox"] {
      accent-color: #2b358d;
      width: initial;
      margin: 0 !important;
    }
    &:hover {
      background: #e6eaf3;
    }
  }
} 

</style>
